import React, { useState } from 'react';
import { useReveal, JoinBlock, PageHeader } from '../components/shared';
import { sendContact } from '../api';

export default function Contact() {
  useReveal([]);
  const [form, setForm] = useState({ name: '', phone: '', email: '', topic: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    if (status === 'sending') return;
    if (!form.name.trim() || !form.email.includes('@') || !form.message.trim()) {
      setStatus('error'); setTimeout(() => setStatus('idle'), 2600); return;
    }
    setStatus('sending');
    try {
      await sendContact(form);
      setStatus('sent');
      setForm({ name: '', phone: '', email: '', topic: '', message: '' });
      setTimeout(() => setStatus("idle"), 6000);
    } catch (e) {
      setStatus('error'); setTimeout(() => setStatus('idle'), 2600);
    }
  };

  const btnLabel = { idle: 'Send Message', sending: 'Sending…', sent: 'Message Sent ✓', error: 'Please check your details' }[status];

  return (
    <div className="page active">
      <PageHeader eyebrow="Torquay Flower Farm" title="Get in Touch" sub="— we'd love to hear from you" />

      <div className="contact-grid" style={{ backgroundImage: 'url(/brand/contact-bg.webp)' }}>
        <div className="cc-info">
          <span className="eyebrow rev">Contact</span>
          <h2 className="rev serif-h" style={{ marginBottom: 16 }}>Let&rsquo;s talk flowers.</h2>
          <p className="rev" style={{ fontSize: 14, lineHeight: 1.8, color: 'var(--mid)', marginBottom: 24 }}>Questions about dahlia tubers, wholesale orders, the farm gate — or just want to talk about flowers? We're here.</p>
          <div className="details rev">
            {[['Instagram', '@southbeachblooms'], ['Location', 'Torquay, VIC 3228'], ['Farm Gate', 'In season · via Instagram'], ['Tuber Sale', 'September 2027 · Community first']].map(([l, v], i) => (
              <div className="d-row" key={i}><span className="d-label">{l}</span><span className="d-val">{v}</span></div>
            ))}
          </div>
          <div className="rev" style={{ marginTop: 24 }}><a href="https://instagram.com/southbeachblooms" target="_blank" rel="noreferrer" className="btn btn-outline">Follow on Instagram</a></div>
        </div>
        <div className="cc-form-wrap">
          <div className="cf-2">
            <div><label className="cf-label">Name</label><input type="text" className="cf-input" placeholder="Your name" value={form.name} onChange={set('name')} /></div>
            <div><label className="cf-label">Phone</label><input type="tel" className="cf-input" placeholder="Phone number" value={form.phone} onChange={set('phone')} /></div>
          </div>
          <label className="cf-label">Email</label><input type="email" className="cf-input" placeholder="your@email.com" value={form.email} onChange={set('email')} />
          <label className="cf-label">Enquiry</label>
          <select className="cf-select" value={form.topic} onChange={set('topic')}>
            <option value="" disabled>Select a topic</option>
            <option>Dahlia Tuber Sale · September 2027</option>
            <option>Bulk / Wholesale Tubers</option>
            <option>Farm Gate</option>
            <option>Wholesale Flowers</option>
            <option>Pick Your Own</option>
            <option>Farmhouse · Shoot / Event / Collaboration</option>
            <option>General Enquiry</option>
          </select>
          <label className="cf-label">Message</label><textarea className="cf-textarea" placeholder="Tell us what you're after..." value={form.message} onChange={set('message')} />
          <button className="cf-submit" disabled={status === 'sending'} style={status === 'sent' ? { background: 'var(--forest)', color: '#fff' } : {}} onClick={submit}>{btnLabel}</button>
        </div>
      </div>

      <JoinBlock eyebrow="Never Miss Out" headline="Join our community.<br>First dibs on everything." body="Tuber sale first access, farm gate updates, growing tips and behind the scenes — all to our community, before anyone else." />
    </div>
  );
}
